import { EDrawingActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const finishDrawing = actionGenerator<EDrawingActionType.DrawingFinished>(EDrawingActionType.DrawingFinished);
